<div mat-subheader *ngIf="item.navCap" class="nav-caption">
  {{ item.navCap }}
</div>
<a
  mat-list-item
  (click)="onItemSelected(item)"
  [ngClass]="{
    'mat-toolbar mat-primary activeMenu': isMenuActive(item.route)
  }"
  class="menu-list-item"
  *ngIf="!item.navCap"
>
  <i-tabler
    class="routeIcon"
    name="{{ item.iconName }}"
    matListItemIcon
  ></i-tabler>
  <span class="hide-menu" >{{ item.displayName }}</span>
</a>
<style>
  .routeIcon{
    display: flex;
  justify-content: center;
  align-items: center;
  }
</style>
